<template>
    <div id="signature-pad" class="signature-pad">
        <div class="signature-pad--body" style="min-height: 316px; width: 100%;">
            <canvas ref="canvasRef" class="canvasId" style="border: 2px dashed #f7f7f7;" ></canvas>
            <img v-if="signImageUrl" :src="signImageUrl" style="width: 100%; height: 300px;" ref="imageRef" />
        </div>
        <p class="desc-text">请在上面区域完成签名 然后点击确"确认"按钮</p>
        <div v-if="!signImageUrl" class="non-printable">
            <el-button plain size="mini" type="danger" @click="clear">清除</el-button>
            <el-button plain size="mini" type="warning" @click="undo">回撤</el-button>
            <!-- 模板相关 -->
            <el-button v-if="isSign" size="mini" type="primary" @click="getSignfUrl">使用模板</el-button>
            <el-button v-else size="mini" type="primary" @click="setSignfUrl">存为模板</el-button>
            <!-- 模板相关结束 -->
            <el-button size="mini" type="success" @click="savePng">确认</el-button>
        </div>
        <div v-if="signImageUrl" class="non-printable">
            <el-button size="mini" type="primary" @click="reSign">重签</el-button>
            <!-- 模板相关 -->
            <el-button v-if="isSign" size="mini" type="primary" @click="getSignfUrl">使用模板</el-button>
            <el-button size="mini" type="primary" @click="setSignfUrl">存为模板</el-button>
            <!-- 模板相关结束 -->
        </div>
    </div>
</template>
  
<script>
import SignaturePad from 'signature_pad'
import { getAction, xhrRequest, findCenterConfig, normalizeUrlSlashes, getCenterId } from '@/utils'
export default {
    name: 'SignPad',
    components: {},
    props: {
        value: {
            type: String,
            default: '',
        },
        color: {
            type: String,
            default: '',
        },
        // 文件上传地址
        action: {
            type: String,
            default: '',
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            signUrl: null,
            isSign: false, // 判断该用户是否存在签名模板
            signaturePad: null,
            canvas: null,
            signImageUrl: null,
            config: {
                minWidth: 1,
                maxWidth: 3,
                penColor: this.color,
            },
        }
    },
    watch: {
        value: {
            handler: function(value) {
                if(value) {
                    this.signImageUrl = value
                    this.$nextTick(() => {
                        this.resetUrl()
                    })
                } else {
                    this.signImageUrl = null
                }
            },
            immediate: true,
            deep: true
        }
    },
    mounted () {
        this.init()
        window.onresize = () => {
            return (() => {
                this.resizeCanvas()
            })()
        }
        this.resizeCanvas()
        this.getSignImg()
    },
    methods: {
        resizeCanvas () {
            // console.log('resizeCanvas'+this.color)
            const canvas = this.canvas
            // When zoomed out to less than 100%, for some very strange reason,
            // some browsers report devicePixelRatio as less than 1
            // and only part of the canvas is cleared then.
            const ratio = Math.max(window.devicePixelRatio || 1, 1)
            // This part causes the canvas to be cleared
            canvas.width = canvas.offsetWidth * ratio
            canvas.height = canvas.offsetHeight * ratio
            canvas.getContext('2d').scale(ratio, ratio)

            // This library does not listen for canvas changes, so after the canvas is automatically
            // cleared by the browser, SignaturePad#isEmpty might still return false, even though the
            // canvas looks empty, because the internal data of this library wasn't cleared. To make sure
            // that the state of this library is consistent with visual state of the canvas, you
            // have to clear it manually.
            this.signaturePad.clear()
        },
        init () {
            this.canvas = this.$refs.canvasRef // document.querySelector('.canvasId')
            const canvas = this.canvas
            this.signaturePad = new SignaturePad(canvas, this.config)
            if(this.readonly) {
                this.signaturePad.off()
            }
            // canvas.height = 300
            // canvas.width = 500
        },
        clear () {
            this.signaturePad.clear()
        },
        undo () {
            const data = this.signaturePad.toData()
            if (data) {
                data.pop() // remove the last dot or line
                this.signaturePad.fromData(data)
            }
        },
        savePng () {
            if (this.signaturePad.isEmpty()) {
                this.$message.error('请先填写签名')
                return
            }
            const data = this.signaturePad.toDataURL('image/png')
            const file = this.dataURLtoFile(data, `${new Date().getTime()}.png`)
            const param = new FormData() // 创建form对象
            param.append('file', file) // 通过append向form对象添加数据

            const { option: { api } } = this.$attrs
            const { uploadFileUrl } = api
            const [ action, params, headers ] = getAction(uploadFileUrl)
            xhrRequest({
                url: typeof (action) === 'function' ? action() : action,
                method: 'POST',
                data: param,
                headers
            }).then(res => {
                this.signaturePad.clear()
                // 若有centerId 则拼图片后面
                let centerId = '?centerId='
                if (window.$centerConfig) {
                    centerId = centerId + window.$centerConfig.centerId
                }
                this.signImageUrl = res.data.downloadUrl + centerId
                this.$emit('input', this.signImageUrl)
            })
            // action(param).then(res => {
            //     this.signaturePad.clear()
            //     this.signImageUrl = res.data.downloadUrl
            //     this.$emit('input', this.signImageUrl)
            // })
        },
        reSign () {
            this.signImageUrl = null
            this.signaturePad.clear()
            this.$emit('input', null)
        },
        dataURLtoFile (dataurl, filename) {
            // 获取到base64编码
            const arr = dataurl.split(',')
            // 将base64编码转为字符串
            const bstr = window.atob(arr[1])
            let n = bstr.length
            const u8arr = new Uint8Array(n) // 创建初始化为0的，包含length个元素的无符号整型数组
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n)
            }
            return new File([u8arr], filename, {
                type: 'image/png',
            })
        },
        /**
         * 使用模板签名
         */
        getSignfUrl () {
            this.getSignImg()
            this.signImageUrl = this.signUrl
            this.$emit('input', this.signImageUrl)
        },
        /**
         * 获取签名模板
         */
        async getSignImg() {
            const { option: { api } } = this.$attrs
            const { getSign } = api
            if(!getSign) return
            const [action, otherParams] = getAction(getSign)
            const res = await action(otherParams);
            if (res.data.length > 0) {
                this.signUrl = res.data[0].signature
                this.isSign = true
            }
        },
        /**
         * 存为模版
         */
        async setSignfUrl () {
            if (this.signImageUrl) {
                const data = { signature: this.signImageUrl }
                const { option: { api } } = this.$attrs
                const { addSign } = api
                if(!addSign) return
                const [ action, otherParams ] = getAction(addSign)
                const res = await action({...data, ...otherParams})
                if (res.code === 200) {
                    this.isSign = true
                    this.$message.success('保存签名成功')
                }
            }
        },
        // reset img url
        resetUrl() {
            const centerId = getCenterId(this.signImageUrl)
            if(centerId && window.$centerConfig) {
                const hostApi = findCenterConfig(centerId, window.$centerConfig)
                if(!hostApi) return
                const url = normalizeUrlSlashes(hostApi + this.signImageUrl)
                console.log(this.$refs.imageRef)
                this.$refs.imageRef.src = url
            }
        }
    },
}
</script>
<style scoped>
*,
*::before,
*::after {
    box-sizing: border-box;
}
.signature-pad {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    font-size: 10px;
    width: 100%;
    height: 100%;
    /*max-width: 900px;*/
    max-height: 460px;
    background-color: #fff;
    border-radius: 4px;
    padding: 16px;
}
.signature-pad::before {
    left: 20px;
    -webkit-transform: skew(-3deg) rotate(-3deg);
    transform: skew(-3deg) rotate(-3deg);
}
.signature-pad::after {
    right: 20px;
    -webkit-transform: skew(3deg) rotate(3deg);
    transform: skew(3deg) rotate(3deg);
}
.signature-pad--body {
    position: relative;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    border: 1px solid #f4f4f4;
}
.signature-pad--body canvas {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 4px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.02) inset;
}
.sign-pad-container {
    padding: 1px;
}
</style>
  